import { useState } from "react";
import { streamAI } from "@/lib/stream";
import { Button } from "@/components/ui/button";
import { Sparkles, RefreshCw } from "lucide-react";

export default function AIInsights({ lotId }) {
  const [text, setText] = useState("");
  const [state, setState] = useState("idle"); // idle | streaming | done | error

  const generate = async () => {
    setText(""); setState("streaming");
    try {
      await streamAI(`/ai/lot-insights/${lotId}`, { onDelta: (t) => setText((s) => s + t) });
      setState("done");
    } catch (e) { setState("error"); }
  };

  return (
    <div className="surface-card p-5 mt-6" data-testid="ai-insights-card">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <h3 className="heading font-semibold flex items-center gap-2">
          <Sparkles className="h-4 w-4 text-[color:var(--earth-amber)]" /> AI Genetic Insights
          <span className="text-[10px] mono uppercase text-stone-400">Claude Sonnet 5</span>
        </h3>
        <Button data-testid="ai-insights-generate-btn" variant="outline" size="sm" onClick={generate} disabled={state === "streaming"}>
          {state === "streaming" ? <><RefreshCw className="h-3.5 w-3.5 mr-1 animate-spin" /> Analyzing…</> : state === "done" ? "Regenerate" : "Generate insights"}
        </Button>
      </div>
      {state === "idle" && <p className="text-sm text-stone-500 mt-3">Get a buyer-focused analysis of this lot's EPDs, conservation implications, and due-diligence checklist.</p>}
      {state === "error" && <p className="text-sm text-red-600 mt-3">Analysis failed — please try again.</p>}
      {text && (
        <div data-testid="ai-insights-text" className="mt-3 text-sm text-stone-700 whitespace-pre-wrap leading-relaxed">
          {text}{state === "streaming" && <span className="inline-block w-2 h-4 bg-[color:var(--earth-amber)] ml-0.5 animate-pulse" />}
        </div>
      )}
    </div>
  );
}
